'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import MediaQuery from 'react-responsive';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _List = require('material-ui/List');

var _Divider = require('material-ui/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _Avatar = require('material-ui/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Subheader = require('material-ui/Subheader');

var _Subheader2 = _interopRequireDefault(_Subheader);

var _colors = require('material-ui/styles/colors');

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _moreVert = require('material-ui/svg-icons/navigation/more-vert');

var _moreVert2 = _interopRequireDefault(_moreVert);

var _IconMenu = require('material-ui/IconMenu');

var _IconMenu2 = _interopRequireDefault(_IconMenu);

var _MenuItem = require('material-ui/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _util = require('@its/util');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// TODO : styling, liste affiancate

var messages = (0, _reactIntl.defineMessages)({
  EDIT: {
    id: 'EDIT',
    description: 'Mark element editable',
    defaultMessage: 'Edit'
  },
  DELETE: {
    id: 'DELETE',
    description: 'Mark element deletable',
    defaultMessage: 'Delete'
  }
});

var listStyle = {
  display: 'block',
  float: 'left',
  width: '100%'
};

var iconButtonElement = _react2.default.createElement(
  _IconButton2.default,
  {
    tooltip: 'more',
    tooltipPosition: 'bottom-left',
    touch: true
  },
  _react2.default.createElement(_moreVert2.default, { color: _colors.grey400 })
);

var getRightIconMenu = function getRightIconMenu(editable, deletable, formatMessage, onEdit, onDelete) {
  if (!editable && !deletable) {
    return null;
  }
  return _react2.default.createElement(
    _IconMenu2.default,
    { key: 'Menu', iconButtonElement: iconButtonElement },
    editable ? _react2.default.createElement(
      _MenuItem2.default,
      { key: 'Edit', onTouchTap: onEdit },
      formatMessage(messages.EDIT)
    ) : undefined,
    deletable ? _react2.default.createElement(
      _MenuItem2.default,
      { key: 'Delete', onTouchTap: onDelete },
      formatMessage(messages.DELETE)
    ) : undefined
  );
};

var getItem = function getItem(formatMessage, currentFilter, item, index) {
  var listItem = void 0;
  if (!currentFilter || item.filter === currentFilter) {
    listItem = _react2.default.createElement(
      'div',
      { key: item.key || item.id },
      index !== 0 ? _react2.default.createElement(_Divider2.default, { key: 'divider', inset: true }) : undefined,
      _react2.default.createElement(_List.ListItem, _extends({
        key: item.key || item.id,
        leftAvatar: _react2.default.createElement(_Avatar2.default, { src: item.image || null, icon: item.icon || null }),
        rightIconButton: getRightIconMenu(item.editable, item.deletable, formatMessage, item.onEdit, item.onDelete)
      }, item))
    );
  }
  return listItem;
};

var getLists = function getLists(props) {
  var items = props.items,
      columns = props.columns,
      intl = props.intl,
      currentFilter = props.currentFilter,
      endSpace = props.endSpace,
      others = _objectWithoutProperties(props, ['items', 'columns', 'intl', 'currentFilter', 'endSpace']);

  var title = props.title;

  title = title ? intl.messages[title] : null;
  var chunks = (0, _util.chunkify)(items, columns, true);
  var lists = [];
  var getListItem = getItem.bind(null, intl.formatMessage, currentFilter);
  for (var i = 0; i < chunks.length; i++) {
    lists.push(_react2.default.createElement(
      _List.List,
      _extends({ key: i }, others),
      _react2.default.createElement(
        _Subheader2.default,
        null,
        title
      ),
      chunks[i].map(getListItem),
      endSpace ? [_react2.default.createElement(_List.ListItem, {
        key: 'firstBlank',
        disabled: true,
        disableKeyboardFocus: true
      }), _react2.default.createElement(_List.ListItem, {
        key: 'secondBlank',
        disabled: true,
        disableKeyboardFocus: true
      })] : null
    ));
  }

  return lists;
};

var toMulticolumn = function toMulticolumn(lists) {
  listStyle.width = 100 / lists.length + '%';
  return lists.map(function (list) {
    return _react2.default.cloneElement(list, { style: listStyle });
  });
};

var ListComponent = function (_React$Component) {
  _inherits(ListComponent, _React$Component);

  function ListComponent() {
    _classCallCheck(this, ListComponent);

    return _possibleConstructorReturn(this, (ListComponent.__proto__ || Object.getPrototypeOf(ListComponent)).apply(this, arguments));
  }

  _createClass(ListComponent, [{
    key: 'render',
    value: function render() {
      var lists = getLists(this.props);
      return _react2.default.createElement(
        'div',
        null,
        lists
      );
    }
  }]);

  return ListComponent;
}(_react2.default.Component);

ListComponent.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  title: _react2.default.PropTypes.string,
  columns: _react2.default.PropTypes.number,
  items: _react2.default.PropTypes.array.isRequired,
  currentFilter: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
  endSpace: _react2.default.PropTypes.bool
};
ListComponent.defaultProps = {
  title: '',
  columns: 1,
  items: [],
  currentFilter: null,
  endSpace: true
};
exports.default = (0, _reactIntl.injectIntl)(ListComponent);

/*

<MediaQuery maxWidth={599}>
  {lists}
</MediaQuery>
<MediaQuery minWidth={600}>
  {toMulticolumn(lists)}
</MediaQuery>

*/


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/List/List.js
 ** module id = 279
 ** module chunks = 0
 **/